import { ApiCore } from "./utilities/core";

const url = 'process_mining/save_process_compare_data';

const apiProcessCompareAutoSave = new ApiCore({
    getAll: false,
    getSingle: true,
    post: false,
    postSingle: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
});

export default apiProcessCompareAutoSave;